import React from "react"
import PropTypes from "prop-types"
import { Flex } from "@chakra-ui/react"
import FormControl from "./form-control"

const styles = {
  root: {
    flexDirection: { base: "column", md: "row", lg: "row" },
    justifyContent: {
      base: "flex-start",
      md: "space-between",
      lg: "space-between",
    },
  },
}

const createFormControlStyles = count => ({
  formGroup: {
    width: {
      base: "100%",
      md: `${100 / count - (count - 1)}%`,
      lg: `${100 / count - (count - 1)}%`,
    },
  },
})

const MultiFormControl = ({ fields, onChange }) => {
  const formControlStyles = React.useMemo(
    () => createFormControlStyles(fields.length),
    [fields.length]
  )
  return (
    <Flex sx={styles.root}>
      {fields.map(field => (
        <FormControl
          key={field.id}
          label={field.label}
          name={field.name}
          type={field.type}
          required={field.required}
          onChange={onChange}
          value={field.value}
          hint={field.hint}
          id={field.id}
          styles={formControlStyles}
        />
      ))}
    </Flex>
  )
}

MultiFormControl.propTypes = {
  fields: PropTypes.array,
  onChange: PropTypes.func,
}

export default MultiFormControl
